import { render, staticRenderFns } from "./WelcomeTourArabic.vue?vue&type=template&id=6664ebaa"
import script from "./WelcomeTourArabic.vue?vue&type=script&lang=js"
export * from "./WelcomeTourArabic.vue?vue&type=script&lang=js"
import style0 from "./WelcomeTourArabic.vue?vue&type=style&index=0&id=6664ebaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports